import { getRetailer } from "@faire/retailer-visitor-shared/serialized-data/getRetailer";
import { useSearchPageCategoryName } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageCategoryName";
import { useSearchPageCategoryUrlId } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageCategoryUrlId";
import { useSearchPageRequestId } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageRequestId";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { headerStyles } from "@faire/retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/SearchStyles";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import trackClick from "@faire/web-api--source/endpoints/www/api/click-track/post";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import { path as c1CategoryPath } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import React from "react";
import styled from "styled-components";

export const MaybeSearchPageCategoryRecommendationLink = () => {
  const retailerToken = getRetailer()?.token;
  const requestId = useSearchPageRequestId();
  const categoryUrlId = useSearchPageCategoryUrlId();
  const categoryName = useSearchPageCategoryName();

  const onClickShopCollection = () => {
    trackClick(
      IClickInfo.build({
        token: retailerToken,
        container_name: "product_search_page_shop_our_collection",
        type: "CATEGORY",
        request_id: requestId,
      })
    );
  };

  if (!categoryName || !categoryUrlId) {
    return null;
  }

  return (
    <CommunityLinkWrapper>
      <Spacer height="3x" />
      <ResponsiveCommunityLink>
        <Typography variant="paragraphSansMedium">
          <StrictLocalMsg
            defaultMessage="Looking for {categoryName}?"
            description={{
              text: "Special link shown when a search query is linked to an existing community collection",
              img: "https://cdn.faire.com/fastly/c25120c3692258f79950b85482049a4be707bdead9386637c3bec2f97f793c8e.png",
            }}
            values={DEPRECATED_backwardsCompatibleValues({
              categoryName: categoryName,
            })}
          />
        </Typography>
        <Spacer size={4} />
        <Button
          variant="tertiary"
          linkTo={c1CategoryPath(categoryUrlId)}
          onClick={onClickShopCollection}
        >
          <Typography variant="paragraphSansMedium">
            <StrictLocalMsg
              defaultMessage="Shop Our Collection"
              description={{
                text: "Special link shown when a search query is linked to an existing community collection",
                img: "https://cdn.faire.com/fastly/c25120c3692258f79950b85482049a4be707bdead9386637c3bec2f97f793c8e.png",
              }}
            />
          </Typography>
        </Button>
      </ResponsiveCommunityLink>
    </CommunityLinkWrapper>
  );
};

const CommunityLinkWrapper = styled.div`
  ${headerStyles};
`;

const ResponsiveCommunityLink = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
